var map = {
	"./MMV.jpg": 152,
	"./NIH.jpg": 153,
	"./bmfoundation.jpg": 155,
	"./ehime.jpg": 156,
	"./kcdc.jpg": 160,
	"./lmrt.jpg": 162,
	"./pennState.jpg": 165,
	"./wtrust.jpg": 170
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;



//////////////////
// WEBPACK FOOTER
// ./src/images/collaborators nonrecursive \.(jpe?g)$
// module id = 173
// module chunks = 74537795826934 162898551421021 176293843571754